"use client"

import { useEffect, useState } from "react"
import Swiper from "swiper/bundle"
import "swiper/css"
import "swiper/css/navigation" // seulement ce que tu utilises
import "swiper/css/bundle"

import Highlighter from "@/components/highlighter"

type Item = {
  format: string
  pseudo?: string
  title?: string
  poster: string
  url: string
  lang?: string
}

export default function ExemplesCarouselClient({ items }: { items: Item[] }) {
  const [swiperInitialized, setSwiperInitialized] = useState(false)
  const [playing, setPlaying] = useState<boolean[]>(() => Array(items.length).fill(false))

  useEffect(() => {
    const swiper = new Swiper(".stellar-carousel2", {
      breakpoints: {
        320: { slidesPerView: 1 },
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      grabCursor: true,
      loop: false,
      spaceBetween: 5,
    })
    setSwiperInitialized(true)
    return () => swiper.destroy()
  }, [])

  const toggleVideo = (index: number, video: HTMLVideoElement) => {
    if (video.paused) {
      video.play()
      setPlaying(prev => prev.map((v, i) => (i === index ? true : v)))
    } else {
      video.pause()
      setPlaying(prev => prev.map((v, i) => (i === index ? false : v)))
    }
  }

  return (
    <div className="stellar-carousel2 swiper-container group px-10">
      <Highlighter className="swiper-wrapper w-fit flex items-center py-4" refresh={swiperInitialized}>
        {items.map((item, index) => {
          const isPlaying = playing[index]
          const isTiktok = item.format === "tiktok"
          const wrapperClass = isTiktok ? "swiper-slide w-fit" : "swiper-slide w-fit double-width-slide"

          return (
            <div key={index} className={wrapperClass} style={{ width: "fit-content" }}>
              <div
                className="relative rounded-3xl overflow-hidden mx-auto"
                style={{
                  backgroundColor: "#666",
                  maxHeight: isTiktok ? "679px" : "auto",
                  maxWidth: isTiktok ? "382px" : "720px",
                }}
              >
                {/* Overlay visible uniquement quand la vidéo est en pause */}
                {!isPlaying && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 text-white transition-opacity duration-300">
                    {item.lang && (
                      <span className="bg-black/50 rounded-xl px-3 py-2 font-bold text-sm mb-3">{item.lang}</span>
                    )}
                    {isTiktok && item.pseudo && (
                      <p className="text-lg font-bold mb-1">@{item.pseudo}</p>
                    )}
                    {isTiktok && item.title && (
                      <p className="text-sm text-center px-4">{item.title}</p>
                    )}
                    <img
                      src="/images/create/play_blanc.png"
                      alt="Play"
                      width={50}
                      height={50}
                      className="mt-6 opacity-90"
                    />
                  </div>
                )}

                <video
                  src={item.url}
                  poster={item.poster}
                  playsInline
                  loop
                  preload="none"
                  className="lazy video__player w-full object-cover"
                  style={{ maxHeight: "100%", cursor: "pointer" }}
                  onClick={(e) => toggleVideo(index, e.currentTarget)}
                  onPlay={() => setPlaying(prev => prev.map((v, i) => (i === index ? true : v)))}
                  onPause={() => setPlaying(prev => prev.map((v, i) => (i === index ? false : v)))}
                />
              </div>
            </div>
          )
        })}
      </Highlighter>
    </div>
  )
}
